import React from "react";
import { subDashboard } from "../../../data/HomeData";
import { BsArrowRightShort } from "react-icons/bs";
const SubDashboard = () => {
  return (
    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-10  px-10 py-10 mt-[-110px]">
      {subDashboard.map((item, index) => (
        <div
          key={index}
          className="flex flex-col  items-center text-center gap-3 "
        >
          <img src={item.icon} alt="" />
          <h3 className="text-xl font-bold">{item.title}</h3>
          <p className="text-accent ">{item.text}</p>
          <a
            href={item.link}
            className="text-primary flex gap-1 items-center font-semibold"
          >
            Learn More <BsArrowRightShort className="text-3xl" />
          </a>
        </div>
      ))}
    </div>
  );
};

export default SubDashboard;
